"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Icons = __importStar(require("@icr-ui/icons"));
const theme_1 = require("@icr-ui/theme");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const Snackbar = (props) => {
    const { label, variant, buttonList, block, Icon, closeToast } = props;
    const IconComponent = Icon
        ? Icons[Icon]
        : null;
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledSnackbarWrapper, { flexDirection: "row", children: (0, jsx_runtime_1.jsxs)(styles_1.StyledSnackbar, { flexDirection: "row", alignItems: "center", justifyContent: "space-between", ...{ label, variant, block }, "data-testid": "snackbar", children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledSnackbarTextBox, { flexDirection: "row", alignItems: "center", justifyContent: "center", children: [Icon
                            ? react_1.default.createElement(IconComponent, {
                                color: theme_1.grayScale[50],
                                width: 24,
                                height: 24,
                            })
                            : null, (0, jsx_runtime_1.jsx)(styles_1.StyledSnackbarText, { variant: "body", size: "small", weight: "medium", "data-testid": "snackbar-label", children: label })] }), (0, jsx_runtime_1.jsx)(styles_1.StyledSnackbarButtonBox, { flexDirection: "row", alignItems: "center", justifyContent: "center", "data-testid": "snackbar-buttons", children: buttonList &&
                        buttonList.map((item, index) => ((0, jsx_runtime_1.jsx)(styles_1.StyledSnackbarButton, { "data-testid": "snackbar-button", onClick: item.onClick, children: item.textButton }, index))) }), (0, jsx_runtime_1.jsx)(styles_1.StyledSnackbarCloseIcon, { onClick: closeToast ? () => closeToast() : undefined, alignItems: "center", justifyContent: "center", "data-testid": "snackbar-close-icon", children: (0, jsx_runtime_1.jsx)(Icons.CloseIcon, { color: theme_1.grayScale[50], width: "16px", height: "16px" }) })] }) }));
};
exports.Snackbar = Snackbar;
exports.Snackbar.displayName = 'Snackbar';
exports.default = exports.Snackbar;
//# sourceMappingURL=snackbar.js.map